import { Button, Paper } from "@material-ui/core";
import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import _ from "lodash";
import { dateTimeReportFormatter } from "../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../fomatters/DecimalFormatter";
import "./Crud.css";
import Loader from "./loader/Loader";

function ReportActionByGame({
  controlledData,
  className = "",
  initialData = [],
  getParams,
  getProcess,
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const cancelTokenSource = useRef(null);

  useEffect(() => {
    if (controlledData) {
      setData(controlledData);
    }
  }, [controlledData]);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const currentCancelToken = cancelTokenSource.current;
    cancelTokenSource.current = axios.CancelToken.source();

    if (currentCancelToken) {
      currentCancelToken.cancel("Canceling previous request");
    }

    setLoading(true);

    const url =
      process.env.REACT_APP_API2_URL + "/Reports/Report_Action_by_Game_2";
    axios
      .post(
        url,
        getParams instanceof Function ? getParams(userInfo) : undefined,
        {
          cancelToken: cancelTokenSource.current.token,
        }
      )
      .then((response) => response.data)
      .then((data) => {
        const params = getParams(userInfo);
        if (params.Sport) {
          data = data.filter((item) => item.IdSport === params.Sport);
        }

        const groupedData = _.groupBy(data, "IdGame");
        _.forEach(groupedData, (values, key) => {
          groupedData[key] = values.map((item, index) => {
            const value = {
              ...item,
              Id: item.IdGame + index,
            };
            return getProcess instanceof Function ? getProcess(value) : value;
          });
        });

        setData(groupedData);
        setLoading(false);
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error(err);
        }
      });

    return () => {
      currentCancelToken.cancel("Component unmounted");
    };
  }, [userInfo, getProcess, getParams]);

  const onSearch = useCallback(() => {
    requestData();
  }, [requestData]);

  /**
   * TABLE OPTIONS
   */
  const options = {
    page: 1, // which page you want to show as default
    sizePerPage: 20, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 5, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "top", // default is bottom, top and both is all available
    withFirstAndLast: true, // Hide the going to First and Last page button
  };

  const regular = ({
    Id,
    VisitorName,
    HomeName,
    Side,
    Total,
    MoneyLine,
    GameDateTime,
    Period,
  }) => (
    <BootstrapTable
      headerContainerClass="hidden"
      className="text-xxs compact-table"
      data={[
        {
          Id: `${Id}V`,
          Game: VisitorName,
          Date: GameDateTime,
          Side: Side,
          Total: Total,
          MoneyLine: MoneyLine,
          SumTotal: Side + Total + MoneyLine,
        },
        {
          Id: `${Id}H`,
          Game: HomeName,
          Date: Period,
          Side: "",
          Total: "",
          MoneyLine: "",
          SumTotal: "",
        },
      ]}
      options={options}
      version="4"
    >
      <TableHeaderColumn dataSort dataField="Id" isKey hidden>
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataSort dataField="Game">
        Game
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort
        dataField="Date"
        dataFormat={dateTimeReportFormatter}
      >
        Date
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort
        dataField="Side"
        dataFormat={decimalInvertedReportFormatter}
      >
        Sides
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort
        dataField="Total"
        dataFormat={decimalInvertedReportFormatter}
      >
        Total
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort
        dataField="MoneyLine"
        dataFormat={decimalInvertedReportFormatter}
      >
        $-Line
      </TableHeaderColumn>
      <TableHeaderColumn
        dataSort
        dataField="SumTotal"
        dataFormat={decimalInvertedReportFormatter}
      >
        Total
      </TableHeaderColumn>
    </BootstrapTable>
  );

  const tnt = (values) => (
    <>
      <BootstrapTable
        headerContainerClass="hidden"
        className="text-xxs compact-table"
        data={[values?.[0], ...values].map(
          (
            { Id, VisitorName, HomeName, GameDateTime, Side, Total, MoneyLine },
            index
          ) => {
            if (index === 0) {
              return {
                Id: `${Id}V`,
                Game: VisitorName,
                Date: GameDateTime,
                Side: Side,
                Total: Total,
                MoneyLine: MoneyLine,
                SumTotal: Side + Total + MoneyLine,
              };
            } else {
              return {
                Id: `${Id}H`,
                Game: HomeName,
                Date: "",
                Side: "",
                Total: "",
                MoneyLine: "",
                SumTotal: "",
              };
            }
          }
        )}
        options={options}
        version="4"
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="Game">
          Game
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="Date"
          dataFormat={dateTimeReportFormatter}
        >
          Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="Side"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sides
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="Total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="MoneyLine"
          dataFormat={decimalInvertedReportFormatter}
        >
          $-Line
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="SumTotal"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </BootstrapTable>
    </>
  );

  const render = (values) => {
    switch (values?.[0].IdSport?.toLowerCase().trim()) {
      case "tnt":
        return tnt(values);
      default:
        return regular(values?.[0]);
    }
  };

  const getTotal = () => {
    const items = _.map(data, (values) => values?.[0]).flat(Infinity);
    return [
      {
        Game: "",
        Date: "Total",
        Side: items.reduce((acc, item) => acc + item.Side, 0),
        Total: items.reduce((acc, item) => acc + item.Total, 0),
        MoneyLine: items.reduce((acc, item) => acc + item.MoneyLine, 0),
        SumTotal: items.reduce(
          (acc, item) => acc + item.Side + item.Total + item.MoneyLine,
          0
        ),
      },
    ];
  };

  if (loading) return <Loader />;
  return (
    <div id="main-div" className={`${className} !h-max flex flex-col gap-4`}>
      <div className="flex flex-row gap-4 mb-4">
        <Button
          type="button"
          onClick={onSearch}
          color="primary"
          variant="contained"
        >
          Search
        </Button>
      </div>

      <h2>Action by Game Report</h2>
      {!_.isEmpty(data) ? (
        <Paper className="flex flex-col gap-4">
          <BootstrapTable
            className="sticky text-xxs compact-table top-4"
            data={[]}
            version="4"
            hover
            bodyContainerClass="hidden"
          >
            <TableHeaderColumn dataField="Id" isKey hidden>
              Id
            </TableHeaderColumn>
            <TableHeaderColumn>Game</TableHeaderColumn>
            <TableHeaderColumn>Date</TableHeaderColumn>
            <TableHeaderColumn>Sides</TableHeaderColumn>
            <TableHeaderColumn>Total</TableHeaderColumn>
            <TableHeaderColumn>$-Line</TableHeaderColumn>
            <TableHeaderColumn>Total</TableHeaderColumn>
          </BootstrapTable>
          {_.map(data, (values, key) => (
            <React.Fragment key={key}>{render(values)}</React.Fragment>
          ))}
          <hr className="border-gray-200" />
          <BootstrapTable
            className="font-bold text-xxs compact-table"
            data={getTotal()}
            version="4"
            hover
            headerContainerClass="hidden"
          >
            <TableHeaderColumn dataSort dataField="Id" isKey hidden>
              Id
            </TableHeaderColumn>
            <TableHeaderColumn dataSort dataField="Game">
              Game
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="Date"
              dataFormat={dateTimeReportFormatter}
            >
              Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="Side"
              dataFormat={decimalInvertedReportFormatter}
            >
              Sides
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="Total"
              dataFormat={decimalInvertedReportFormatter}
            >
              Total
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="MoneyLine"
              dataFormat={decimalInvertedReportFormatter}
            >
              $-Line
            </TableHeaderColumn>
            <TableHeaderColumn
              dataSort
              dataField="SumTotal"
              dataFormat={decimalInvertedReportFormatter}
            >
              Total
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      ) : null}
    </div>
  );
}

export default ReportActionByGame;
